import React, { useContext, useState } from "react";
import { Button, Icon, message } from "antd";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import style from "./index.module.scss";
import CountDown from "components/CourseComponents/CountDown";
import moment from "moment";
import CourseHeader from "../../../components/CourseHeader";
import {
    endExercise,
    ExerciseInfo,
    ExerciseStatus,
    getExerciseInfo
} from "service/exercise";
import usePromiseCallback from "utils/usePromiseCallback";
import { errorMessage } from "service/service";
import useRequest from "../../../../../utils/useRequest";
import useVerifyExercise from "../../../../../utils/useVerifyExercise";
import useRequestFn from "../../../../../utils/useRequestFn";

export default function ExerciseDetailHeader({
    exerciseInfo,
    onClick
}: {
    exerciseInfo: ExerciseInfo;
    onClick: () => void;
}) {
    const history = useHistory();
    const { course, basename } = useContext(CourseContext);
    const [data, setData] = useState(exerciseInfo);
    const [, , getExercise] = useRequest(
        () => getExerciseInfo(data.exerciseId),
        { autoStart: false }
    );
    const [callEndExercise, endExerciseStatus] = useRequestFn(endExercise);
    const { onVerify } = useVerifyExercise();

    const verifyList = [
        {
            verifyStatus: ExerciseStatus.del,
            noticeContent: "练习活动已删除",
            toDo: () => history.push(`${basename}/exercise`)
        },
        {
            verifyStatus: ExerciseStatus.done,
            noticeContent: "练习活动已结束",
            toDo: () =>
                history.push(`${basename}/exercise/statics/${data.exerciseId}`)
        }
    ];

    // 结束练习
    const onEndClick = usePromiseCallback(async function () {
        try {
            await callEndExercise(data.exerciseId, course.weekTimeId);
            history.replace(`${basename}/exercise/statics/${data.exerciseId}`);
        } catch (e) {
            message.error(errorMessage(e));
        }
    });

    async function finishExercise() {
        try {
            const executeContinue = await onVerify(data.exerciseId, verifyList);
            if (executeContinue) {
                await onEndClick();
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    async function onEnd() {
        try {
            const exerciseInfo = await getExercise();
            if (data.validityTime === exerciseInfo.validityTime) {
                history.replace(
                    `${basename}/exercise/statics/${data.exerciseId}`
                );
            } else {
                setData(exerciseInfo);
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    async function onSetting() {
        try {
            const executeContinue = await onVerify(data.exerciseId, verifyList);
            if (executeContinue) {
                onClick();
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <CourseHeader
            title={data.exerciseName}
            info={
                <span>
                    {data.validityTime && (
                        <span>
                            活动时长{" "}
                            {data.validityTime === "不限"
                                ? data.validityTime
                                : `${data.validityTime}分钟`}
                        </span>
                    )}
                    {(data.startTime || data.endTime) && (
                        <span>
                            &nbsp;|&nbsp;
                            {data.startTime && (
                                <>
                                    开始时间{" "}
                                    {moment(data.startTime).format(
                                        "MM-DD HH:mm"
                                    )}
                                    &nbsp;&nbsp;
                                </>
                            )}
                            {data.endTime && (
                                <>
                                    结束时间{" "}
                                    {moment(data.endTime).format("MM-DD HH:mm")}
                                </>
                            )}
                        </span>
                    )}
                </span>
            }
            extra={
                <div className={style.right}>
                    <CountDown
                        key={data.validityTime}
                        startTime={moment(data.startTime).format(
                            "YYYY-MM-DD HH:mm:ss"
                        )}
                        validityTime={
                            data.validityTime === "不限"
                                ? 0
                                : parseInt(data.validityTime)
                        }
                        onEnd={onEnd}
                    />
                    {/*<button className={style.settingBtn} onClick={onSetting}>*/}
                    {/*    <Icon type="setting" />*/}
                    {/*</button>*/}
                    <Button
                        type="primary"
                        ghost
                        className={style.button}
                        onClick={finishExercise}
                        loading={endExerciseStatus.loading}>
                        {!endExerciseStatus.loading && <Icon type="poweroff" />}
                        结束活动
                    </Button>
                </div>
            }
        />
    );
}
